import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * Menu Management Services
 * !== 메뉴 관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/menu-scrn`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ptl/menuscrn/menu-scrn`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0104007q: `${BASE.path}/osci0104007q`, // Menu and Screen List !== 메뉴화면 연결 목록 ==!
    osci0104008s: `${BASE.path}/osci0104008s`, // Menu and Screen Detail !== 메뉴화면 연결 상세 ==!
    osci0104009q: `${BASE.path}/osci0104009q`, // Menu and Screen Detail !== 메뉴화면 연결 상세 ==!
};

export const PGEUIDS = {
    osci0104007q: "osci0104007q",
    osci0104008s: "osci0104008s",
    osci0104009q: "osci0104009q",
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Select Menu and Screen List !== 메뉴화면 연결목록 조회==!
    getMenuScrnList: (data: any, ptlTpCd: any) => api.get(`${BASE.api}/${data}?ptlTpCd=${ptlTpCd}`),

    // Save Menu and Screen !== 메뉴화면 연결 저장==!
    saveMenuScrnList: (data: any) => api.post(`${BASE.api}`, data),
};

export const SF_MENU_MGMT: TFormSchema = {
    id: "form_menuMgmt",
    schema: {
        menuNm: { type: "text", label: "L_MENU_NM", edit: false },
        menuPath: { type: "text", label: "L_MENU_PATH", edit: false },
        menuOrd: { type: "number", label: "L_MENU_ORD", maxLength: 4 },
        uprMenuId: { type: "text", label: "L_UPR_MENU_ID", edit: false },
        uprMenuNm: { type: "text", label: "L_UPR_MENU_NM", edit: false },
        menuId: { type: "text", label: "L_MENU_ID", edit: false },
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            excludes: ["COM"],
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B"],
        },
        menuNmKO: { required: true, type: "text", label: "L_MENU_NM_KO" },
        menuNmEN: { required: true, type: "text", label: "L_MENU_NM_EN" },
        menuNmTZ: { type: "text", label: "L_MENU_NM_TZ" },
    },
};

export const SF_SCRN_MGMT_SRCH: TFormSchema = {
    id: "form_scrnMgmtSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            excludes: ["COM"],
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B"],
        },
        scrnId: { type: "text", label: "L_SCRN_ID" },
        scrnNm: { type: "text", label: "L_SCRN_NM" },
    },
};

export const SF_MENU_SCRN_SRCH: TFormSchema = {
    id: "form_menuScrnSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            excludes: ["COM"],
            defaultValue: "OSC",
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
            defaultValue: "O",
        },
        scrnId: { type: "text", label: "L_SCRN_ID", letterCase: "lower" },
        scrnNm: { type: "text", label: "L_SCRN_NM" },
        menuId: { type: "text" },
        menuPath: { type: "text", edit: false, label: "L_MENU_PATH" },
    },
};

export const SG_SCRN_LIST: TGridSchema = {
    id: "grid_scrnList",
    options: { index: true, pagination: "out", height: 400 },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: 150 }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: 200 }] },
        { cells: [{ header: "L_SCRN_URL_ADDR", binding: "scrnUrlAddr", width: 200 }] },
        { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
        { show: false, cells: [{ binding: "chkYn" }] },
        { show: false, cells: [{ binding: "menuCnctYn" }] },
        { show: false, cells: [{ binding: "menuId" }] },
    ],
    body: [
        { cells: [{ binding: "scrnId" }] },
        { cells: [{ binding: "scrnNm", align: "left" }] },
        { cells: [{ binding: "scrnUrlAddr", align: "left" }] },
        { cells: [{ binding: "scrnDesc", align: "left" }] },
        { cells: [{ binding: "chkYn" }] },
        { cells: [{ binding: "menuCnctYn" }] },
        { cells: [{ binding: "menuId" }] },
    ],
};

export const SG_MENU_SCRN_LIST: TGridSchema = {
    id: "grid_menuScrnList",
    options: { checkbox: true, height: 200 },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: "*" }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "*" }] },
        { cells: [{ header: "L_SCRN_URL_ADDR", binding: "scrnUrlAddr", width: "*" }] },
        { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
        { cells: [{ header: "L_MENU_CNCT_YN", binding: "menuCnctYn", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "scrnId", edit: false }] },
        { cells: [{ binding: "scrnNm", edit: false }] },
        { cells: [{ binding: "scrnUrlAddr", align: "left", edit: false }] },
        { cells: [{ binding: "scrnDesc", align: "left", edit: false }] },
        {
            cells: [
                {
                    binding: "menuCnctYn",
                    type: "select",
                    align: "center",
                    edit: true,
                    required: true,
                    options: [
                        { label: "L_CD_YES", value: "Y" },
                        { label: "L_CD_NO", value: "N" },
                    ],
                },
            ],
        },
    ],
};
